var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversationConferConsultSpeakSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 24.4,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,36.7l-14.5,5.3l-14-6.5C24.7,35.2,23.9,35,23,35c-0.8,0-3.5,0-4.2,0c-3.5,0-6.3,2.9-6.4,6.4v26.4 c0,1.8,0.7,3.4,1.9,4.6c0,0,2.3,43.1,2.3,43.3c0,2.9,2.3,5.2,5.2,5.2c2.7,0,5-2.1,5.2-4.8c0,0,0,0,0,0l0-0.3c0,0,0-0.1,0-0.1 c0,0,0,0,0,0l1.4-44.2c0.7-1,1.1-2.3,1.1-3.5V45.5l8.4,3.9c0.9,0.5,2,0.5,2.9,0.2l16-5.8c2-0.8,2.9-2.8,2.3-4.8 C58.1,37,56,36,54,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,4.6c-6.3,0-11.4,2.7-11.4,5.9c0,1.3,0.8,2.5,2.2,3.5l-3.1,5.7l7.3-3.9c1.5,0.4,3.2,0.6,5,0.6 c6.3,0,11.4-2.7,11.4-5.9C59.5,7.2,54.4,4.6,48.1,4.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.4,
    cy: 24.4,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8,35c-0.8,0-3.5,0-4.2,0c-1,0-2.3,0.4-3,1l-12.5,12l-14.5-5.3c-2-0.8-4.1,0.3-5,2.3c-0.7,2,0.3,4.1,2.3,4.8l16,5.8 c0.9,0.3,2,0.3,2.9-0.2l7.4-5.7l0,18.2c0.1,1.3,0.5,2.6,1.1,3.5l1.4,44.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1l0,0.3c0,0,0,0,0,0 c0.2,2.7,2.4,4.8,5.2,4.8c2.9,0,5.2-2.3,5.2-5.2c0-0.1,2.3-43.3,2.3-43.3c1.2-1.2,1.9-2.8,1.9-4.6V41.4 C115.1,37.9,112.3,35,108.8,35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4,30.3L91.6,32l-6.1-3.5c1.4-1,2.2-2.2,2.2-3.5c0-3.3-5.1-5.9-11.4-5.9C70.1,19.1,65,21.7,65,25 c0,3.3,5.1,5.9,11.4,5.9C78.2,30.9,79.9,30.7,81.4,30.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationConferConsultSpeakSvgrepoCom);
export default __webpack_public_path__ + "static/media/conversation-confer-consult-speak-svgrepo-com.6cdd6495dc09af9806fe6ee4433a6cfa.svg";
export { ForwardRef as ReactComponent };